import { handleActions } from 'redux-actions';
import { types } from './actions';
import { types as SessionActionsTypes } from '../session/actions';

const initialState = {
  id: '',
  name: '',
  administrator: {},
  location: {
    latitude: 0,
    longitude: 0
  },
  timeZone: '',
  communityNumbers: [],
  dssEnabled: false,
  zkEnabled: false,
  dssUrl: null,
  zkUrl: null,
  findCommunityByIdInProgress: false,
  findCommunityByIdHasFailed: false,
  findCommunityGatesInProgress: false,
  findCommunityGatesHasFailed: false,
  findInfractionsSettingsInProgress: false,
  findInfractionsSettingsHasFailed: false,
  apiErrors: null,
  settings: null,
  gates: []
};

const reducer = handleActions(
  {
    [types.findCommunityByIdInProgress]: state => {
      return {
        ...state,
        findCommunityByIdInProgress: true,
        findCommunityByIdHasFailed: false,
        apiErrors: null
      };
    },
    [types.findCommunityByIdFail]: (state, action) => {
      return {
        ...state,
        findCommunityByIdInProgress: false,
        findCommunityByIdHasFailed: true,
        apiErrors: action.payload.apiErrors
      };
    },
    [types.findCommunityByIdSuccess]: (state, action) => {
      const community = action.payload;
      return {
        ...state,
        findCommunityByIdInProgress: false,
        findCommunityByIdHasFailed: false,
        apiErrors: null,
        id: community.id,
        name: community.name,
        administrator: community.administrator,
        communityNumbers: community.communityNumbers,
        location: community.location,
        timeZone: community.timeZone,
        dssEnabled: community.dssEnabled || Boolean(community.dssUrl),
        zkEnabled: community.zkEnabled || Boolean(community.zkUrl),
        dssUrl: community.dssUrl,
        zkUrl: community.zkUrl,
        contractRules: community?.contractRules,
        settings: community?.settings
      };
    },
    [types.findCommunityGatesInProgress]: state => {
      return {
        ...state,
        findCommunityGatesInProgress: true,
        findCommunityGatesHasFailed: false,
        apiErrors: null
      };
    },
    [types.findCommunityGatesFail]: (state, action) => {
      return {
        ...state,
        findCommunityGatesInProgress: false,
        findCommunityGatesHasFailed: true,
        apiErrors: action.payload.apiErrors
      };
    },
    [types.findCommunityGatesSuccess]: (state, action) => {
      return {
        ...state,
        findCommunityGatesInProgress: false,
        findCommunityGatesHasFailed: false,
        apiErrors: null,
        gates: action.payload
      };
    },
    [types.findInfractionsSettingsInProgress]: state => {
      return {
        ...state,
        findInfractionsSettingsInProgress: true,
        findInfractionsSettingsHasFailed: false,
        apiErrors: null
      };
    },
    [types.findInfractionsSettingsFail]: (state, action) => {
      return {
        ...state,
        findInfractionsSettingsInProgress: false,
        findInfractionsSettingsHasFailed: true,
        apiErrors: action.payload.apiErrors
      };
    },
    [types.findInfractionsSettingsSuccess]: (state, action) => {
      return {
        ...state,
        findInfractionsSettingsInProgress: false,
        findInfractionsSettingsHasFailed: false,
        apiErrors: null,
        settings: action.payload
      };
    },
    [SessionActionsTypes.logOff]: () => {
      return initialState;
    }
  },
  initialState
);

export default reducer;
